import React, { Component } from 'react';
import { Grid, Row, Col, Panel, ButtonToolbar, Button, Breadcrumb } from 'react-bootstrap';
import { Field } from 'redux-form';
import { Translate } from 'react-redux-i18n';
import moment from 'moment';
import momentLocalizer from 'react-widgets/lib/localizers/moment';

import ContentWrapper from '../../../components/Layout/ContentWrapper';
import { UI_HEIGHT } from '../../Common/constants';
import Spinner from '../../../components/Widgets/spinner';
import { DisabledInputField } from '../../Common/inputField';
import { Selection } from '../../Common/selection';
import SIPaymentFormTable from './SIPaymentFormTable';

momentLocalizer(moment);

class SIPaymentForm extends Component {
    static contextTypes = {
      router: React.PropTypes.object
    };

    constructor() {
      super();
      this.state = {
        tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton,
        rows: [],
      };

      this.handleResize = this.handleResize.bind(this);
    }

    componentWillMount() {
      const { params: { id } } = this.props;
      if (id && /[0-9]+/.test(id)) {
        this.props.fetchSalesInvoiceDetail(id);
      } else {
        this.props.router.push('/salesInvoicePayment');
      }
    }

    componentDidMount() {
      window.addEventListener('resize', this.handleResize);
    }

    componentWillReceiveProps(nextProps) {
      if (nextProps.salesInvoiceDetail != null && nextProps.salesInvoiceDetail !== this.props.salesInvoiceDetail) {
        const { salesInvoiceDetail } = nextProps;
        if (salesInvoiceDetail.Sales_Invoice_Lines) {
          this.setState({ rows: salesInvoiceDetail.Sales_Invoice_Lines });
        } else {
          this.setState({ rows: [] });
        }
      }
    }

    componentWillUnmount() {
      window.removeEventListener('resize', this.handleResize);
      this.props.resetCurrentSalesInvoice();
      this.props.resetSalesInvoicePayment();
    }

    handleResize() {
        this.setState({ tableHeight: window.innerHeight - UI_HEIGHT.twoLineButton });
    }

    handleFormSubmit = (formProps) => {
      this.setState({ dirty: false });
      if (!this.checkPermission('change_purchase_payment')) {
        const { params: { id }, salesInvoiceDetail } = this.props;

        let { Note, PaymentStatusRecord } = formProps;
        Note = Note || '';
        PaymentStatusRecord = PaymentStatusRecord && PaymentStatusRecord.value;
        if (PaymentStatusRecord === '') {
          PaymentStatusRecord = salesInvoiceDetail.PaymentStatusRecord;
        }
        // test if url id param is valid
        if (id && /[0-9]+/.test(id)) {
          this.props.updateSalesInvoicePayment(id, { Note, PaymentStatusRecord });
        } else {
          alert('Invalid sales invoice ID');
        }
      } else {
        alert('You have no permission!');
      }
    }

    checkPermission(permission) {
      return false;
    }

    renderSIInformation() {
      const { salesInvoiceDetail, detailIsLoading, detailError } = this.props;
      if (detailIsLoading && !detailError) {
        return <Spinner />;
      } else if (this.props.detailError) {
        return (
          <ContentWrapper>
            <div className='alert alert-danger'>{this.props.detailError}</div>
          </ContentWrapper>
        );
      }
      const {
        SONum,
        Sales_User_Name: salesPerson,
        Customer_Number: customerNum,
        Customer_Name: customerName,
        Customer_Description: customerDescription,
        OrderDate,
        ETADate,
        PostingDate,
        SOFinalPrice,
        TotalPrice: totalPrice,
        FinalPrice: finalPrice,
      } = salesInvoiceDetail || {};
      return (
        <Panel>
          <Col xs={2}>
            <label className='receive-form-label'><Translate value="details" /></label>
            <Row>
              <label className='col-sm-4 marginTopStyle po-information'><Translate value="si_no" /></label>
              <Col sm={7}>
                <Field name='InvoiceNum' component={DisabledInputField} />
              </Col>
            </Row>
          </Col>
          <Col xs={2}>
            <label className='receive-form-label'><Translate value="sales" /></label>
            <Row>
              <Col sm={6}>
                <label><Translate value="so_no" /></label>
              </Col>
              <Col sm={6}>
                {SONum}
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="sales_person" /></label>
              </Col>
              <Col sm={6}>
                {salesPerson}
              </Col>
            </Row>
            <Row>
              <label className='col-sm-6 marginTopStyle' ><Translate value="note" /></label>
              <Col sm={6}>
                <Field
                  name='Note'
                  component='Textarea'
                  className='form-control'
                  style={{ minHeight: '55px', maxHeight: '55px' }}
                />
              </Col>
            </Row>
          </Col>
          <Col xs={2}>
            <label className='receive-form-label'><Translate value="customer" /></label>
            <Row>
              <Col sm={6}>
                <label><Translate value="customer_id" /></label>
              </Col>
              <Col sm={6}>
                {customerNum}
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="name" /></label>
              </Col>
              <Col sm={6}>
                {customerName}
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="description" /></label>
              </Col>
              <Col sm={6}>
                {customerDescription}
              </Col>
            </Row>
          </Col>
          <Col xs={2}>
            <label className='receive-form-label'><Translate value="dates" /></label>
            <Row>
              <Col sm={6}>
                <label><Translate value="order_date" /></label>
              </Col>
              <Col sm={6}>
                { OrderDate && moment(OrderDate).format('MM/DD/YYYY') }
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="eta_date" /></label>
              </Col>
              <Col sm={6}>
                { ETADate && moment(ETADate).format('MM/DD/YYYY') }
              </Col>
            </Row>
            <Row>
              <Col sm={6}>
                <label><Translate value="create_date" /></label>
              </Col>
              <Col sm={6}>
                { PostingDate && moment(PostingDate).format('MM/DD/YYYY') }
              </Col>
            </Row>
          </Col>
          <Col xs={2}>
            <label className='receive-form-label'><Translate value="invoice_details" /></label>
              <Row>
                <Col sm={6}>
                  <label><Translate value="so" /><span className='dollar-sign'>$$</span></label>
                </Col>
                <Col sm={6}>
                  { SOFinalPrice }
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <label><Translate value="total" /><span className='dollar-sign'>$$</span></label>
                </Col>
                <Col sm={6}>
                  {totalPrice}
                </Col>
              </Row>
              <Row>
                <Col sm={6}>
                  <label><Translate value="final" /><span className='dollar-sign'>$$</span></label>
                </Col>
                <Col sm={6}>
                  {finalPrice}
                </Col>
              </Row>
              { this.renderPaymentStatus() }
          </Col>
        </Panel>
      );
    }

    renderTable() {
      if (this.props.detailIsLoading && !this.props.detailError) {
        return <Spinner />;
      } else if (this.props.detailError) {
        return (
          <ContentWrapper>
            <div className='alert alert-danger'>{this.props.detailError}</div>
          </ContentWrapper>
        );
      }

      const { rows } = this.state;

      return (
        <Row>
          <Col sm={12}>
            <SIPaymentFormTable rows={rows} />
          </Col>
        </Row>
      );
    }

    renderPaymentStatus() {
      const paymentStatusOptions = [
        { value: 'Not Paid', label: <Translate value="not_paid" /> },
        { value: 'Partially Paid', label: <Translate value="partially_paid" /> },
        { value: 'Paid', label: <Translate value="paid" /> },
      ];

      const { salesInvoiceDetail } = this.props;
      let defaultPayment = null;
      if (salesInvoiceDetail) {
        const paymentStatusRecord = salesInvoiceDetail.PaymentStatusRecord;
        defaultPayment = { value: paymentStatusRecord, label: paymentStatusRecord };
      }

      return (
        <Row>
          <Col sm={6}>
            <label><Translate value="payment_status" /> <span style={{ color: 'red' }} >*</span> </label>
          </Col>
          <Col sm={6}>
            <Field
              name='PaymentStatusRecord'
              component={Selection}
              options={paymentStatusOptions}
              defaultValue={defaultPayment}
            />
          </Col>
        </Row>
      );
    }

    renderResponse() {
      const { salesInvoicePaymentUpdated, updateSalesInvoicePaymentError, salesInvoicePaymentIsUpdating } = this.props;
      if (salesInvoicePaymentUpdated) {
        return (
          <ContentWrapper>
            <div className='alert alert-success'>Success!</div>
          </ContentWrapper>
        );
      } else if (salesInvoicePaymentIsUpdating && !updateSalesInvoicePaymentError) {
        return (
          <ContentWrapper>
            <div className='alert alert-info'>
              ...<Translate value="updating_data" />
            </div>
          </ContentWrapper>
        );
      } else if (updateSalesInvoicePaymentError) {
        return (
          <ContentWrapper>
            <div className='alert alert-danger'>
              {updateSalesInvoicePaymentError}
            </div>
          </ContentWrapper>
        );
      }
      return <ContentWrapper />;
    }

    render() {
      const { handleSubmit, salesInvoiceDetail, detailIsLoading, detailError } = this.props;
      if (detailIsLoading && !detailError) {
        return <Spinner />;
      } else if (this.props.detailError) {
        return (
          <ContentWrapper>
            <div className='alert alert-danger'>{this.props.detailError}</div>
          </ContentWrapper>
        );
      }
      return (
        <ContentWrapper>
          <form onSubmit={handleSubmit(this.handleFormSubmit)} >
            <Breadcrumb>
              <Breadcrumb.Item>
                <Translate value="ar_slashsign_ap" />
              </Breadcrumb.Item>
              <Breadcrumb.Item active='true'>
                <Translate value="si_payment_details" />
              </Breadcrumb.Item>
            </Breadcrumb>
            <ButtonToolbar>
              <Button
                onClick={() => { this.context.router.push('/salesInvoicePayment'); }}
                bsStyle='danger'
              >
                <em className='fa fa-close' />
              </Button>
              <Button
                className='btn btn-primary'
                style={{ marginRight: '20px' }}
                type='submit'
              >
                <em className='fa fa-save' style={{ marginRight: '10px' }} />
                <Translate value="save" />
              </Button>
            </ButtonToolbar>
            <Grid fluid='true' id='purchase-payment-detail'>
              <Row>
                <h2 className='mt0'><Translate value="si_payment" /></h2>
                <h3>{ salesInvoiceDetail && salesInvoiceDetail.WarehouseName }</h3>
              </Row>
              <Row>
                { this.renderResponse() }
              </Row>
              <Row>
                { this.renderSIInformation() }
              </Row>
              <Panel>
                { this.renderTable() }
              </Panel>
            </Grid>
          </form>
        </ContentWrapper>
      );
    }
}

export default SIPaymentForm;



// WEBPACK FOOTER //
// ./master/jsx/components/AR/SIPaymentForm/SIPaymentForm.jsx